import React, { useCallback } from 'react';
import {
  ClassroomCode,
  CloseButton,
  Container,
  Content,
  CopyButton,
  ShareBox,
  ShareLink,
} from './styles';
import { ClassroomIcon, CrossIcon } from '../../assets/svg/SVGComponents';
import { useModal } from '../../hooks/modal';

interface ClassroomsProps {
  code: string;
}

const ShareClassroom: React.FC<ClassroomsProps> = ({ code }) => {
  const { closeModal } = useModal();

  const handleClose = useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Container>
      <header>
        <div>
          <ClassroomIcon
            width="2rem"
            height="2rem"
            stroke="#ff9800"
            strokeWidth={1.5}
            fill="none"
          />
          <h1>Sala de Aula</h1>
        </div>

        <CloseButton
          type="button"
          onClick={handleClose}
          aria-label="Fechar modal"
          title="Fechar modal"
        >
          <CrossIcon
            width="1.6rem"
            height="1.6rem"
            stroke="#323650"
            strokeWidth={1.8}
          />
        </CloseButton>
      </header>
      <Content>
        <div>
          <h3>1 - Compartilhe a URL abaixo com seus alunos.</h3>
          <ShareBox>
            <ShareLink
              href="https://aula.fuzzymakers.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://aula.fuzzymakers.com/
            </ShareLink>
            <CopyButton
              type="button"
              onClick={() =>
                navigator.clipboard.writeText('https://aula.fuzzymakers.com/')
              }
              aria-label="Copiar link"
              title="Copiar link"
            >
              Copiar
            </CopyButton>
          </ShareBox>
          <h3>2 - Compartilhe o código da sala de aula com seus alunos.</h3>

          <ClassroomCode>{code}</ClassroomCode>
        </div>
      </Content>
    </Container>
  );
};

export default ShareClassroom;
